import React, { useEffect, useState } from 'react'
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { gridStyles, gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import styles from "../refundApproval/style.module.scss";
import { formattedPrice } from 'views/pages/manage/unAssigned/collectPayment/utils';
import moment from "moment";
import { getFormattedDate, getUpdatedTime } from "views/pages/manage/employeeManagement/userProfile/helper";


const NewReceipts = ({
  refundType,
  isLoading,
  newReceiptList = [],
}) => {

  const columns = [
    ...(refundType === 'INTERNAL_REFUND' ? [
      new AGridColDef("courseId", "Course ID", false)
        .setMinWidth(40)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip> : <div>-</div>
        )),
    ] : []),
    new AGridColDef("paymentMode", "Paymode", false)
      .setMinWidth(40)
      .editable(true)
      .setFlex(0.5)
      .renderCellComponent((params) => {
        const dispValue = params?.value?.split("_")?.[0];
        return (dispValue ? <Tooltip title={dispValue}>
          <div className={`ellipsis-text-container`}>{dispValue}</div>
        </Tooltip> : <div>-</div>)
      }),
    ...(refundType === 'INTERNAL_REFUND'
      ? [
        new AGridColDef("newReceiptId", "Receipt Number", false)
          .setMinWidth(110)
          .editable(true)
          .setFlex(0.9)
          .renderCellComponent((params) =>
            params?.value ? (
              <Tooltip title={params.value}>
                <div className="ellipsis-text-container">{params.value}</div>
              </Tooltip>
            ) : (
              <div>-</div>
            )
          ),

        new AGridColDef("newReceiptDate", "Receipt Date & Time", false)
          .setMinWidth(100)
          .editable(true)
          .setFlex(0.9)
          .renderCellComponent((params) =>
            params?.value ? (
              <Tooltip title={`${getFormattedDate(params?.value)} at ${getUpdatedTime(params?.value)}`}>
                <div className="ellipsis-text-container">
                  {`${getFormattedDate(params?.value)} at ${getUpdatedTime(params?.value)}`}
                </div>
              </Tooltip>
            ) : (
              <div>-</div>
            )
          ),
      ]
      : []),

    ...(refundType !== 'INTERNAL_REFUND'
      ? [
        new AGridColDef("paidAmount", "Payment Amount", false)
          .setMinWidth(120)
          .editable(true)
          .setFlex(1)
          .renderCellComponent((params) =>
            params?.value ? (
              <Tooltip title={formattedPrice(params?.value)}>
                <div className={`ellipsis-text-container ${styles['amount']}`}>
                  {formattedPrice(params?.value)}
                </div>
              </Tooltip>
            ) : (
              <div>-</div>
            )
          ),
      ]
      : []),
  ];

  return (
    <div className="" style={{ border: '1px solid #EEE', borderRadius: '12px' }}>
      <div className="dark-text label-color" style={{ padding: '1rem 2rem' }}>{refundType !== 'INTERNAL_REFUND' ? "New Receipt" : "Positive Receipt"}</div>
      <div className='' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
      <ADataGrid
        removeWrapperContainer
        rowModesModel
        rows={newReceiptList || []}
        columns={columns}
        rowId={(row) => JSON.stringify(row)}
        rowHeight={50}
        rowCount={newReceiptList.length}
        loading={false}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={isLoading ? "Loading..." : null} />
          ),
        }}
        sx={{
          ...gridStyles,
        }}
        autoHeight
        hidePagination={true}
      />

      {(newReceiptList?.length > 0 && refundType === 'INTERNAL_REFUND') && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem 2rem",
            borderTop: "1px solid #E2E2E2",
            background: "#FAFAFA",
          }}
        >
          <div style={{ display: "flex", gap: "2rem" }}>
            <div className="dark-text">Refund Amount</div>
            <div className={styles.amount}>
              {formattedPrice(newReceiptList[0]?.receiptAmount)}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default NewReceipts;